import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { generateId } from '../../../_core/utils/generate-id';

// TODO delete when update to newer typescript version
type ToggleEvent = Event & {
  newState: 'open' | 'closed',
  oldState: 'open' | 'closed',
}

@Component({
  selector: 'opac-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
})
export class PopoverComponent {
  isOpen = false;

  /**
   * Sets aria labelled by attribute
   */
  @Input() ariaLabelledBy: string | undefined = undefined;
  /**
   * Sets the popover id for aria accessibility
   */
  @Input() id: string = generateId();
  /**
   * Sets popover role for aria accessibility
   */
  @Input() role: string | undefined = undefined;
  /**
   * Popover native element
   */
  @ViewChild('popover') popover!: ElementRef<HTMLDivElement>;

  /**
   * Triggers when popover is light dismissed (esc key, background click)
   */
  popoverClosed$ = new Subject<void>();

  top: number = 0;
  left: number = 0;

  handlePopupToggle(event: ToggleEvent) {
    if (event.newState === 'closed' && this.isOpen) {
      this.popoverClosed$.next();
    }
  }
}
